import type { Editor, JSONContent } from "@tiptap/core";
import { nodeContentToText } from "./document-serializer";

/**
 * The Block menu's Bullet list and Numbered list: the paragraphs under the selection become one
 * Lilia list block, one item each, marks kept in the item text (**bold**, $x$ …) as paragraphs
 * keep them. The first paragraph's block id carries over, so the save is a change of type.
 *
 * TipTap's own bullet and ordered lists are not in the document editor: nothing saved them, and a
 * paragraph turned into one vanished from the document on the next save (16 Oct).
 */
export function paragraphsToList(editor: Editor, ordered: boolean): boolean {
  const { state, view } = editor;
  const listType = state.schema.nodes.listBlock;
  if (!listType) return false;
  const { $from, $to } = state.selection;
  const first = $from.index(0);
  const last = Math.max(first, $to.index(0));

  const items: string[] = [];
  let blockId: string | null = null;
  for (let i = first; i <= last; i++) {
    const node = state.doc.child(i);
    if (node.type.name !== "paragraph") {
      if (items.length === 0) return false;
      break;
    }
    if (blockId === null) blockId = (node.attrs.blockId as string | null) ?? null;
    items.push(nodeContentToText(((node.toJSON() as JSONContent).content ?? []) as JSONContent[]));
  }
  if (items.length === 0) return false;

  let start = 0;
  for (let i = 0; i < first; i++) start += state.doc.child(i).nodeSize;
  let end = start;
  for (let i = first; i < first + items.length; i++) end += state.doc.child(i).nodeSize;

  const list = listType.create({ blockId, items, ordered, kind: ordered ? "numbered" : "bullet" });
  view.dispatch(state.tr.replaceWith(start, end, list).scrollIntoView());
  return true;
}
